import { Reveal } from '@/components/Reveal';

export const Chapters = ({ items, eyebrow, title }) => (
  <section data-testid="numbered-chapters" className="py-20 md:py-28">
    <div className="mx-auto max-w-site px-5 md:px-8">
      {(eyebrow || title) && (
        <div className="mb-14 md:mb-20 max-w-2xl">
          {eyebrow && <p className="text-xs uppercase tracking-[0.25em] font-semibold text-primary mb-4">{eyebrow}</p>}
          {title && <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight leading-tight">{title}</h2>}
        </div>
      )}
      <div className="divide-y divide-border border-t border-b border-border">
        {items.map((item, i) => (
          <Reveal key={item.num} delay={i * 0.06}>
            <div className="grid md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 items-start" data-testid={`chapter-${item.num}`}>
              <div className="md:col-span-3">
                <span className="font-heading text-6xl md:text-8xl font-bold text-brand-light/70 leading-none select-none">{item.num}</span>
              </div>
              <div className="md:col-span-9">
                <h3 className="font-heading text-2xl md:text-3xl font-bold tracking-tight mb-4">{item.title}</h3>
                <p className="text-base md:text-lg leading-relaxed text-foreground/70 max-w-2xl">{item.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
